import { unref as x, onUnmounted as v, watch as j, isRef as C, getCurrentInstance as U, getCurrentScope as A, onScopeDispose as M, onMounted as k, nextTick as R } from "vue";
function q(t) {
  return A() ? (M(t), !0) : !1;
}
function z(t, n) {
  return x(t);
}
function T(t) {
  return typeof t == "function" ? t() : x(t);
}
const H = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const J = (t) => t != null, G = Object.prototype.toString, K = (t) => G.call(t) === "[object Object]", O = () => {
};
function S(t, n) {
  function e(...r) {
    return new Promise((o, u) => {
      Promise.resolve(t(() => n.apply(this, r), { fn: n, thisArg: this, args: r })).then(o).catch(u);
    });
  }
  return e;
}
const L = (t) => t();
function V(t, n = {}) {
  let e, r, o = O;
  const u = (s) => {
    clearTimeout(s), o(), o = O;
  };
  return (s) => {
    const h = T(t), a = T(n.maxWait);
    return e && u(e), h <= 0 || a !== void 0 && a <= 0 ? (r && (u(r), r = null), Promise.resolve(s())) : new Promise((f, i) => {
      o = n.rejectOnCancel ? i : f, a && !r && (r = setTimeout(() => {
        e && u(e), r = null, f(s());
      }, a)), e = setTimeout(() => {
        r && u(r), r = null, f(s());
      }, h);
    });
  };
}
function _(...t) {
  let n = 0, e, r = !0, o = O, u, p, s, h, a;
  !C(t[0]) && typeof t[0] == "object" ? { delay: p, trailing: s = !0, leading: h = !0, rejectOnCancel: a = !1 } = t[0] : [p, s = !0, h = !0, a = !1] = t;
  const f = () => {
    e && (clearTimeout(e), e = void 0, o(), o = O);
  };
  return (c) => {
    const l = T(p), m = Date.now() - n, y = () => u = c();
    return f(), l <= 0 ? (n = Date.now(), y()) : (m > l && (h || !r) ? (n = Date.now(), y()) : s && (u = new Promise((d, w) => {
      o = a ? w : d, e = setTimeout(() => {
        n = Date.now(), r = !0, d(y()), f();
      }, Math.max(0, l - m));
    })), !h && !e && (e = setTimeout(() => r = !0, l)), r = !1, u);
  };
}
function N(t, n = !1, e = "Timeout") {
  return new Promise((r, o) => {
    setTimeout(n ? () => o(e) : r, t);
  });
}
function Q(t, n) {
  var e;
  if (typeof t == "number")
    return t + n;
  const r = ((e = t.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : e[0]) || "", o = t.slice(r.length), u = Number.parseFloat(r) + n;
  return Number.isNaN(u) ? t : u + o;
}
function W(t) {
  return U();
}
function X(t, n = 200, e = {}) {
  return S(
    V(n, e),
    t
  );
}
function E(t, n, e = {}) {
  const {
    eventFilter: r = L,
    ...o
  } = e;
  return j(
    t,
    S(
      r,
      n
    ),
    o
  );
}
function Y(t, n = !0, e) {
  W() ? k(t, e) : n ? t() : R(t);
}
function Z(t, n) {
  W() && v(t, n);
}
function F(t, n = !1) {
  function e(i, { flush: c = "sync", deep: l = !1, timeout: m, throwOnTimeout: y } = {}) {
    let d = null;
    const P = [new Promise((g) => {
      d = j(
        t,
        (b) => {
          i(b) !== n && (d == null || d(), g(b));
        },
        {
          flush: c,
          deep: l,
          immediate: !0
        }
      );
    })];
    return m != null && P.push(
      N(m, y).then(() => T(t)).finally(() => d == null ? void 0 : d())
    ), Promise.race(P);
  }
  function r(i, c) {
    if (!C(i))
      return e((b) => b === i, c);
    const { flush: l = "sync", deep: m = !1, timeout: y, throwOnTimeout: d } = c ?? {};
    let w = null;
    const g = [new Promise((b) => {
      w = j(
        [t, i],
        ([D, B]) => {
          n !== (D === B) && (w == null || w(), b(D));
        },
        {
          flush: l,
          deep: m,
          immediate: !0
        }
      );
    })];
    return y != null && g.push(
      N(y, d).then(() => T(t)).finally(() => (w == null || w(), T(t)))
    ), Promise.race(g);
  }
  function o(i) {
    return e((c) => !!c, i);
  }
  function u(i) {
    return r(null, i);
  }
  function p(i) {
    return r(void 0, i);
  }
  function s(i) {
    return e(Number.isNaN, i);
  }
  function h(i, c) {
    return e((l) => {
      const m = Array.from(l);
      return m.includes(i) || m.includes(T(i));
    }, c);
  }
  function a(i) {
    return f(1, i);
  }
  function f(i = 1, c) {
    let l = -1;
    return e(() => (l += 1, l >= i), c);
  }
  return Array.isArray(T(t)) ? {
    toMatch: e,
    toContains: h,
    changed: a,
    changedTimes: f,
    get not() {
      return F(t, !n);
    }
  } : {
    toMatch: e,
    toBe: r,
    toBeTruthy: o,
    toBeNull: u,
    toBeNaN: s,
    toBeUndefined: p,
    changed: a,
    changedTimes: f,
    get not() {
      return F(t, !n);
    }
  };
}
function $(t) {
  return F(t);
}
function tt(t, n, e = {}) {
  const {
    throttle: r = 0,
    trailing: o = !0,
    leading: u = !0,
    ...p
  } = e;
  return E(
    t,
    n,
    {
      ...p,
      eventFilter: _(r, o, u)
    }
  );
}
export {
  L as bypassFilter,
  S as createFilterWrapper,
  V as debounceFilter,
  z as get,
  W as getLifeCycleTarget,
  Q as increaseWithUnit,
  H as isClient,
  K as isObject,
  O as noop,
  J as notNullish,
  N as promiseTimeout,
  _ as throttleFilter,
  tt as throttledWatch,
  T as toValue,
  Y as tryOnMounted,
  q as tryOnScopeDispose,
  Z as tryOnUnmounted,
  $ as until,
  X as useDebounceFn,
  tt as watchThrottled,
  E as watchWithFilter
};
//# sourceMappingURL=index-es.js.map
